import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import {
  LOAD_COLLECTION_DETAILS_PAGE,
  LOAD_RESOURCE_DETAILS_PAGE,
  SUBMIT_FAVORITE_FROM_COLLECTION_PAGE,
  SUBMIT_FAVORITE_FROM_EXPLORE_PAGE,
  SUBMIT_FAVORITE_FROM_FAVORITES_PAGE,
  SUBMIT_FAVORITE_FROM_RESOURCE_PAGE,
} from './actions'

import {
  getAllResourcesService,
  getCollectionDetailsService,
  getCollectionResourcesService,
  getFavoritesService,
  getResourceDetailsService,
  postFavoriteService,
  setResourceDetailsFavorite,
} from './index'

interface ActionPayload {
  payload: any
}

function* submitFavoriteFromFavoritesPageSaga({ payload }: ActionPayload): any {
  // @ts-ignore - Complex saga typing issues
  const favoriteResult: any = yield call(postFavoriteService.requestSaga, { payload })
  if (favoriteResult.error) return
  // @ts-ignore
  yield call(getFavoritesService.requestSaga, {})
}

function* submitFavoriteFromCollectionPageSaga({ payload }: ActionPayload): any {
  const queryId = payload.data.collection_slug

  // @ts-ignore
  const favoriteResult: any = yield call(postFavoriteService.requestSaga, { payload })
  if (favoriteResult.error) return
  // @ts-ignore
  yield call(getCollectionResourcesService.requestSaga, { payload: { urlParams: queryId } })
}

function* submitFavoriteFromResourcePageSaga({ payload }: ActionPayload): any {
  // @ts-ignore
  const favoriteResult: any = yield call(postFavoriteService.requestSaga, { payload })
  if (favoriteResult.error) return
  yield put(setResourceDetailsFavorite(payload.data.resource_id, Boolean(payload.data.favorite)))
}

function* submitFavoriteFromExplorePageSaga({ payload }: ActionPayload): any {
  // @ts-ignore
  const favoriteResult: any = yield call(postFavoriteService.requestSaga, { payload })
  if (favoriteResult.error) return
  // @ts-ignore
  yield call(getAllResourcesService.requestSaga, {})
}

function* loadResourceDetailsPageSaga({ payload }: ActionPayload): any {
  // @ts-ignore
  yield call(getResourceDetailsService.requestSaga, {
    payload: { urlParams: payload.slug, req: payload.req },
  })
  const resourceItem: any = yield select((state: any) => state.resource.details.item)
  if (resourceItem) {
    // @ts-ignore
    yield call(getCollectionDetailsService.requestSaga, {
      payload: { urlParams: resourceItem.collection_slug, req: payload.req },
    })
    // @ts-ignore
    yield call(getCollectionResourcesService.requestSaga, {
      payload: { urlParams: resourceItem.collection_slug, req: payload.req },
    })
  }
}

function* loadCollectionDetailsPageSaga({ payload }: ActionPayload): any {
  // @ts-ignore
  yield call(getCollectionDetailsService.requestSaga, {
    payload: { urlParams: payload.slug, req: payload.req },
  })
  const collectionItem: any = yield select((state: any) => state.collection.details.item)
  if (collectionItem) {
    // @ts-ignore
    yield call(getCollectionResourcesService.requestSaga, {
      payload: { urlParams: collectionItem.slug, req: payload.req },
    })
  }
}

export default function* saga(): any {
  yield all([
    // @ts-ignore - Complex saga typing issues with redux-saga
    takeLatest(SUBMIT_FAVORITE_FROM_FAVORITES_PAGE, submitFavoriteFromFavoritesPageSaga),
    // @ts-ignore
    takeLatest(SUBMIT_FAVORITE_FROM_COLLECTION_PAGE, submitFavoriteFromCollectionPageSaga),
    // @ts-ignore
    takeLatest(SUBMIT_FAVORITE_FROM_RESOURCE_PAGE, submitFavoriteFromResourcePageSaga),
    // @ts-ignore
    takeLatest(SUBMIT_FAVORITE_FROM_EXPLORE_PAGE, submitFavoriteFromExplorePageSaga),
    // @ts-ignore
    takeLatest(LOAD_RESOURCE_DETAILS_PAGE, loadResourceDetailsPageSaga),
    // @ts-ignore
    takeLatest(LOAD_COLLECTION_DETAILS_PAGE, loadCollectionDetailsPageSaga),
  ])
}
